export const root = "rmlsczl";
export const link = "l1t5iy5l";
export const signUpLink = "s11lkfty";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");